/**
 * Extend the dialog.js of Ajax Cart Pro module before dialog is open, hide the freeshipping container
 * as sometimes user won't close dialog by clicking close button or continue shopping, which leave the
 * freeshipping container displayed next time dialog is opened by clicking `ADD TO BAG` again. Also we
 * display freeshipping container when content is allowed to show
 */

define(["jquery", "pdpAddToBagModal"], function ($, pdpAddToBagModal) {
  "use strict";

  return function (widget) {
    $.widget("awacp.acpDialog", widget, {
      freeshippingContainerSelector: ".product-free-shipping-indicator",
      messageContainerSelector: ".aw-acp-popup__message",
      submitButtonWrapperSelector: ".aw-acp-popup__submit-wrapper",

      _beforeFire: function (event, actionId, redirectToCatalog) {
        this._super(event, actionId, redirectToCatalog);
        
        window.dispatchEvent(new Event("pdp-add-to-bag"));

        pdpAddToBagModal.onChangeRedirectOnContinueClickOutcome(
          this.redirectOnContinueClick
        );
      },

      busy: function () {
        pdpAddToBagModal.presentBeforeOpening_whileAddingToBag_loading();
      },

      _close: function () {
        pdpAddToBagModal.close();
      },

      _afterUpdate: function (event, actionId, addSuccess) {
        if (this.actionId == actionId) {
          this.showContent(addSuccess);
        }
      },

      showContent: function (addSuccess) {
        if (addSuccess) {
          pdpAddToBagModal.presentAddToBagSuccess();
        } else {
          pdpAddToBagModal.presentAddToBagFailure();
        }
      },
    });

    return $.awacp.acpDialog;
  };
});
